import axios from 'axios';


const BASE_URL = `${process.env.REACT_APP_API_URL}/api/dashboard`;


// Fetch number of users
export const fetchUsersCount = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/users/count`);
    return response.data.count;
  } catch (error) {
    console.error('Error fetching users count:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch number of travel agencies
export const fetchAgenciesCount = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/travel-agencies/count`);
    return response.data.count;
  } catch (error) {
    console.error('Error fetching agencies count:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch number of tourist centers
export const fetchCentersCount = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/tourist-centers/count`);
    return response.data.count;
  } catch (error) {
    console.error('Error fetching tourist centers count:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch monthly user registration data with optional year filter
export const fetchMonthlyUserData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/users/monthly`, {
        params: { year: new Date().getFullYear() },
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching monthly user data:", error);
      throw error;
    }
  };
  
// Fetch monthly agencies data with optional year filter
export const fetchMonthlyAgenciesData = async (year = new Date().getFullYear()) => {
  try {
    const response = await axios.get(`${BASE_URL}/travel-agencies/monthly`, { params: { year } });
    return response.data.monthlyData;
  } catch (error) {
    console.error('Error fetching monthly agencies data:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch monthly tourist centers data with optional year filter
export const fetchMonthlyCentersData = async (year = new Date().getFullYear()) => {
  try {
    const response = await axios.get(`${BASE_URL}/tourist-centers/monthly`, { params: { year } });
    return response.data.monthlyData;
  } catch (error) {
    console.error('Error fetching monthly centers data:', error.response ? error.response.data : error.message);
    throw error;
  }
};